export default class GridLayoutOnPLP {
    constructor(variant) {
        this.variantValues = {
            "a-4-2-grid-layout": {
                desktop: "large",
                mobile: "half",
            },
            "b-3-1-grid-layout": {
                desktop: "medium",
                mobile: "one",
            },
        };
        this.variantValue = this.variantValues[variant];
    }
}
